import { routes, type EventsListResponse, type MeEventTab } from '@spot/shared';
import { useInfiniteQuery } from '@tanstack/react-query';

import { useSession } from '../auth/session-gate';
import { filterParams, type MapFilters } from '../map/filters';

export function nearbyQueryKey(city: string, filters: MapFilters) {
	return ['events', 'list', { city, ...filterParams(filters) }] as const;
}

export function myEventsQueryKey(tab: MeEventTab) {
	return ['me', 'events', tab] as const;
}

const nextCursor = (page: EventsListResponse) => page.nextCursor ?? undefined;

/** Activities → Поруч: the city's events with the map's filters, soonest first. */
export function useNearbyEvents(city: string, filters: MapFilters) {
	const { api } = useSession();
	return useInfiniteQuery({
		queryKey: nearbyQueryKey(city, filters),
		queryFn: ({ pageParam }) =>
			api.call(routes.listEvents, {
				query: {
					city,
					...filterParams(filters),
					...(pageParam === undefined ? {} : { cursor: pageParam }),
				},
			}),
		initialPageParam: undefined as string | undefined,
		getNextPageParam: nextCursor,
		staleTime: 30_000,
	});
}

/** Activities → Мої, one tab. */
export function useMyEvents(tab: MeEventTab) {
	const { api } = useSession();
	return useInfiniteQuery({
		queryKey: myEventsQueryKey(tab),
		queryFn: ({ pageParam }) =>
			api.call(routes.myEvents, {
				query: { tab, ...(pageParam === undefined ? {} : { cursor: pageParam }) },
			}),
		initialPageParam: undefined as string | undefined,
		getNextPageParam: nextCursor,
		staleTime: 30_000,
	});
}
